export default {
  Roles(state) {
    return state.Roles;
  },
  Nations(state) {
    return state.Nations;
  },
  NationsEmployee(state) {
    return state.NationsEmployee;
  },
  Partners(state) {
    return state.Partners;
  }
};